import React from 'react';
import { Box, Container, VStack, Heading, Text } from '@chakra-ui/react';
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';

const MentionsLegales = () => {
  return (
    <Box minH="100vh" display="flex" flexDirection="column" bg="linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)">
      <Header />
      <Box as="main" flex="1" pt={["100px", "100px", "90px", "90px"]}>
        <Box
          left="50%"
          ml="-50vw"
          w="100vw"
          position="relative"
          bg="linear-gradient(135deg, #0053b3 0%, #ef3340 100%)"
          py={{ base: 12, lg: 16 }}
        >
          <Container maxW="1200px" px={5}>
            <Heading as="h1" size={{ base: 'xl', md: '2xl' }} color="white" fontWeight={800} textAlign="center">
              📜 Mentions légales
            </Heading>
          </Container>
        </Box>

        <Container maxW="1000px" px={5} py={10}>
          <VStack spacing={8} align="start">
            <Box bg="white" borderRadius="2xl" p={{ base: 6, md: 8 }} boxShadow="0 10px 30px rgba(0,0,0,0.08)">
              <Heading as="h2" size="md" mb={4}>Éditeur du site</Heading>
              <VStack align="start" spacing={2}>
                <Text>Le site Rester en France, accessible à l’adresse https://rester-en-france.fr, est édité par :</Text>
                <Text fontWeight={700}>UNISAVE LTD</Text>
                <Text>Société enregistrée au Royaume-Uni</Text>
                <Text>Siège social : 207 Regent Street, W1B 3HH, Londres, Royaume-Uni</Text>
                <Text>Numéro d’immatriculation (Companies House) : 14217440</Text>
                <Text>E-mail : contact@rester-en-france.fr</Text>
              </VStack>
            </Box>

            <Box bg="white" borderRadius="2xl" p={{ base: 6, md: 8 }} boxShadow="0 10px 30px rgba(0,0,0,0.08)">
              <Heading as="h2" size="md" mb={4}>Hébergement</Heading>
              <Text>(à compléter – nom, adresse et site web de l’hébergeur, par ex. Vercel, OVH, etc.)</Text>
            </Box>

            <Box bg="white" borderRadius="2xl" p={{ base: 6, md: 8 }} boxShadow="0 10px 30px rgba(0,0,0,0.08)">
              <Heading as="h2" size="md" mb={4}>Activité</Heading>
              <VStack align="start" spacing={2}>
                <Text>Le site Rester en France est une plateforme privée d’assistance administrative.</Text>
                <Text>Il propose un accompagnement dans la préparation et la gestion des démarches suivantes :</Text>
                <VStack align="start" spacing={1} pl={4}>
                  <Text>• Demandes et renouvellements de titres de séjour</Text>
                  <Text>• Demandes de visa</Text>
                  <Text>• Recours OQTF</Text>
                  <Text>• Contestations de décisions administratives</Text>
                </VStack>
                <Text>Rester en France n’est pas un site gouvernemental.</Text>
                <Text>Ce site est édité par une société privée et n’a aucun lien avec l’administration française, les préfectures, le ministère de l’Intérieur ou tout autre service public.</Text>
                <Text>Les utilisateurs peuvent réaliser gratuitement leurs démarches sur les sites officiels de l’administration française, notamment sur https://www.service-public.fr.</Text>
              </VStack>
            </Box>

            <Box bg="white" borderRadius="2xl" p={{ base: 6, md: 8 }} boxShadow="0 10px 30px rgba(0,0,0,0.08)">
              <Heading as="h2" size="md" mb={4}>Données personnelles</Heading>
              <VStack align="start" spacing={2}>
                <Text>Les informations recueillies via le site sont destinées exclusivement à la gestion des demandes et au suivi des dossiers.</Text>
                <Text>Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d’un droit d’accès, de rectification, d’effacement, d’opposition et de portabilité de vos données.</Text>
                <Text>Pour exercer ces droits, vous pouvez adresser une demande par e-mail à : contact@rester-en-france.fr.</Text>
              </VStack>
            </Box>

            <Box bg="white" borderRadius="2xl" p={{ base: 6, md: 8 }} boxShadow="0 10px 30px rgba(0,0,0,0.08)">
              <Heading as="h2" size="md" mb={4}>Propriété intellectuelle</Heading>
              <Text>L’ensemble du contenu du site (textes, images, graphismes, logo, icônes, structure, etc.) est la propriété exclusive de UNISAVE LTD, sauf mention contraire. Toute reproduction, représentation, modification ou utilisation non autorisée est interdite sans l’accord écrit préalable de l’éditeur.</Text>
            </Box>

            <Box bg="white" borderRadius="2xl" p={{ base: 6, md: 8 }} boxShadow="0 10px 30px rgba(0,0,0,0.08)">
              <Heading as="h2" size="md" mb={4}>Limitation de responsabilité</Heading>
              <Text>UNISAVE LTD s’efforce d’assurer la fiabilité et la mise à jour des informations publiées sur le site. Cependant, aucune garantie n’est apportée quant à l’exactitude, la complétude ou la pertinence des contenus. L’utilisateur reconnaît utiliser le site sous sa seule responsabilité.</Text>
            </Box>
          </VStack>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default MentionsLegales;
